<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot-scope="scope" slot="menuLeft">
            <p style="display:inline-block;margin-right:25px">已领取:
                <span style="color:#4D8344">{{receivedMoney}}</span>/
                <span>{{redPacketTotal}}元</span>,
                <span style="color:#4D8344">{{receivedNum}}</span>/
                <span>{{redPacketNumber}}个</span>
            </p>
            <!-- <el-button
            type="primary"
            icon="el-icon-tickets"
            size="small"
            plain
            @click.stop="downloadExcelRedPacketDetail"
          >导出Excel</el-button> -->
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >重命名</el-button>
          <el-button
            type="danger"
            size="small"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >删除</el-button>
        </template>

        <template slot-scope="scope" slot="nameForm">
          <!-- <el-select v-model="currClassify" clearable placeholder="请选择系统大类">
            <el-option
              v-for="item in classifySelects"
              :key="item.id"
              :label="item.rootName"
              :value="item.id"
            ></el-option>
          </el-select>-->
          <el-select
            v-model="currClassify"
            filterable
            remote
            reserve-keyword
            placeholder="请输入手机号"
            :remote-method="remoteMethod"
            :loading="loading"
          >
            <el-option
              v-for="item in classifySelects"
              :key="item.id"
              :label="item.realName"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { mobileRedPacketDetailOption } from "@/const/salesCloud/mobileRedPacketDetailOption";
import {
  findDetails,
  getReceivedInfo
} from "@/api/salesCloud/mobileRedPacketDetail";
import { excelaxios } from "@/util/excelaxios";

export default {
  name: "mobileRedPacketDetail",
  data() {
    return {
      tableOption: mobileRedPacketDetailOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      loading: false,
      receivedMoney:0,
      redPacketTotal:0,
      receivedNum:0,
      redPacketNumber:0,
      classifySelects: [],
      currClassify: [],
      tabelObj: {},
      ids: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      }
    };
  },
  created() {

    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {},
  props: [],
  methods: {
    clean() {
      this.currClassify = "";
      this.classifySelects = [];
    },
    searchClear() {
      this.currClassify = "";
    },
    choseClassifyItem() {
      console.log(this.currClassify);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      (params.redPacketId = this.$route.params.id),
        (params.page = this.page.currentPage);
      params.size = pageSize;
      this.downloadData = params;
      findDetails(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      (params.redPacketId = this.$route.params.id),
        (params.size = this.page.pageSize);
      this.downloadData = params;
      findDetails(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      (params.redPacketId = this.$route.params.id), console.log(params);
      findDetails(params).then(res => {
        if (res.code != 500) {
          let data = JSON.parse(res.data);
          this.tableData = data.rows;
          this.page = {
            total: data.total,
            currentPage: params.page,
            pageSize: params.size
          };
          this.tableLoading = false;
        } else {
          this.tableLoading = false;
          this.tableData = [];
          console.log(11);
        }
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      (params.redPacketId = this.$route.params.id),
        (params.size = page.pageSize);
        console.log(this.$route)
      this.downloadData = params;
      console.log(page);
     
      findDetails(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      // this.clean()
      this.clean();
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      // this.clean()
      // this.clientType = this.formatClientType(row.useCustomerType)
      // this.joinsWorkServiceCategory = {id: row.serviceCategoryId}
      // this.choseWorkServiceItem();
      // this.joinsWorkServiceItem = {id: row.serviceItemId}
      // if (row.startTime != null && row.endTime != null) {
      //     let array = []
      //     array.push(row.startTime)
      //     array.push(row.endTime)
      //     row.startTime_endTime = array
      // }
      console.log(row);
      this.clean();
      this.currClassify = row.rootId == 0 ? (row.rootId = "") : row.rootId;
      this.$refs.crud.rowEdit(row, index);
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        redPacketId: this.$route.params.id,
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      findDetails(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
         let id =this.$route.params.id
      getReceivedInfo(id).then(res=>{
          console.log(res)
           let data = JSON.parse(res.data);
           this.receivedMoney=data.receivedMoney
           this.redPacketTotal=data.redPacketTotal
           this.receivedNum=data.receivedNum
           this.redPacketNumber=data.redPacketNumber
      })
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      console.log(row);
      addTags(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange(val) {
      let ids = val.map(item => {
        return item.id;
      });
      this.ids = ids.join(",");
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row) {
      console.log(row);
      let ids = "";
      ids = this.ids;
      if (row) {
        ids = row.id;
        console.log(ids);
      }
      console.log(ids);
      this.$confirm(
        `删除标签后，该标签下的所有用户将失去该标签属性。是否确定删除?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          delTags(ids)
            .then(res => {
              if (res.code == "200") {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      console.log(row.id);
      editTags(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "编辑成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    downloadExcelRedPacketDetail() {
      let data = this.downloadData;
      console.log(params);
    let params = {
        redPacketId:data.redPacketId
    }
      let url = `/joins-sales/v1/redPacket/downloadExcel?`;
      excelaxios(url, params);
    //  this.$router.push({ path: 'joins-sales/v1/redPacket/downloadExcel' })
    },
  }
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
